module.exports = __webpack_public_path__ + "img/instagram.1001dd4c.svg";